/**
 * The till's „დინ-დონ" for a new online order (lib/order-alerts.ts): two soft
 * sine notes made on the spot — no sound file to download.
 *
 * A browser lets a page play sound only after a press on it. `unlockChime`
 * runs on the first press or key and wakes the audio; until then `playChime`
 * stays silent (the message still shows). The audio is never created before
 * that press, so Chrome has nothing to warn about.
 */
let ctx: AudioContext | null = null

export function unlockChime(): void {
  try {
    if (!ctx) {
      const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
      if (!AC) return
      ctx = new AC()
    }
    if (ctx.state === 'suspended') void ctx.resume().catch(() => {})
  } catch {
    // no audio on this device: the message alone will do
  }
}

export function playChime(): void {
  if (!ctx || ctx.state !== 'running') return
  const start = ctx.currentTime
  for (const [freq, at] of [[880, 0], [1318.5, 0.18]] as const) {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'sine'
    osc.frequency.value = freq
    gain.gain.setValueAtTime(0.0001, start + at)
    gain.gain.exponentialRampToValueAtTime(0.3, start + at + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, start + at + 0.45)
    osc.connect(gain).connect(ctx.destination)
    osc.start(start + at)
    osc.stop(start + at + 0.5)
  }
}
